export default __webpack_public_path__ + "static/media/desktop_logo.9c94c46f.png";